import React, { useEffect } from 'react';

const FomoPopup = () => {
    useEffect(() => {
        const fomoPopup = document.querySelector('.fomo_popup') as HTMLElement;
        const targetElement = document.querySelector('.search-results__popup') as HTMLElement;

        if (fomoPopup && targetElement) {
            targetElement.appendChild(fomoPopup);

            setTimeout(function () {
                fomoPopup.style.display = 'flex';
                fomoPopup.style.opacity = '1';
            }, 3000);

            setTimeout(function () {
                fomoPopup.style.opacity = '0';
                setTimeout(() => {
                    fomoPopup.style.display = 'none'; // Hide the element after transition completes
                }, 1000); //
            }, 10000);
        }

    }, []);

    return (
        <div className="search-results__popup"></div>
    );
};

export default FomoPopup;
